import { useEffect, useState } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { AddPhotoAlternateOutlined, CameraAltOutlined } from '@mui/icons-material';
import ImageBox from './ImageBox';
import UploadFrame from '../../../assets/UploadFileBoxCircle.png';

export const ImageUpload = ({
  name,
  inputProps,
  onChange,
  src,
  selectedImageProps,
  buttonProps,
  error,
  helperText,
  Isvideo = false,
  empty = false,
}) => {
  const [selectedFile, setSelectedFile] = useState();
  const [preview, setPreview] = useState();
  const [extension, setExtension] = useState('');
  const isLegacyPlaceholder = !selectedFile && (empty || (
    typeof src === 'string' && /(createNFTUpload|UploadFileBoxCircle)/i.test(src)
  ));
  const hasImage = Boolean(selectedFile || (src && !isLegacyPlaceholder));

  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const onSelectFile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      onChange(name, null);
      return;
    }

    const extension = e.target.files[0].name.split('.').pop();
    /* 		const isExtenstionMatch=fasle;
		if (inputProps?.accept) {
			const accept = inputProps?.accept || ""
			if(accept.includes("image")){
				 imagesTypeStatic.includes(extension);
			}

		} */
    setExtension(extension);

    onChange(name, e.target.files[0]);

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  };
  let child = (
    <ImageBox
      extension={typeof src === 'string' && src?.split('.')?.pop()}
      src={src ? src : UploadFrame}
      {...selectedImageProps}
    />
  );
  if (selectedFile) {
    child = <ImageBox extension={Isvideo && extension} src={preview} {...selectedImageProps} />;
  }
  return (
    <>
      <ButtonBase
        htmlFor={name}
        component="label"
        sx={{
          position: 'relative', width: '100%', minHeight: 132, p: 1.2, overflow: 'hidden',
          border: '1.5px dashed', borderColor: error ? '#ef4444' : '#b9c8dc', borderRadius: '12px', bgcolor: '#f8fbff',
          transition: 'border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease',
          '&:hover': { borderColor: error ? '#ef4444' : '#1769e8', bgcolor: '#f3f8ff', boxShadow: '0 6px 18px rgba(23, 105, 232, .07)' },
        }}
        {...buttonProps}
      >
        <input type="file" id={name} onChange={onSelectFile} hidden name={name} {...inputProps} />
        <Box sx={{ width: '100%', display: 'grid', placeItems: 'center', '& .image-wrapper': { maxHeight: 170 }, '& img': { maxHeight: 170 } }}>
          {isLegacyPlaceholder ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.7, py: 2 }}>
              <Box sx={{ width: 48, height: 48, display: 'grid', placeItems: 'center', borderRadius: '13px', bgcolor: '#e7f0ff', color: '#1769e8' }}>
                <AddPhotoAlternateOutlined sx={{ fontSize: 25 }} />
              </Box>
              <Typography sx={{ color: '#172b4d', fontSize: 13, fontWeight: 750 }}>Choose a profile photo</Typography>
              <Typography sx={{ color: '#718096', fontSize: 11 }}>Click to browse an image</Typography>
            </Box>
          ) : child}
        </Box>
        <Box sx={{ position: 'absolute', right: 10, bottom: 10, display: 'flex', alignItems: 'center', gap: 0.6, px: 1.1, py: 0.6, borderRadius: '999px', bgcolor: 'rgba(15, 35, 70, .88)', color: '#fff', boxShadow: '0 4px 12px rgba(15, 35, 70, .2)' }}>
          <CameraAltOutlined sx={{ fontSize: 15 }} />
          <Typography sx={{ fontSize: 10.5, fontWeight: 700 }}>{hasImage ? 'Change' : 'Upload'}</Typography>
        </Box>
      </ButtonBase>
      {error && (
        <Typography
          className="block text-red-500 pl-1 Mui-error"
          sx={{
            fontWeight: '400',
            fontSize: '0.75rem',
            lineHeight: '1.66',
            letterSpacing: '0.03333em',
            textAlign: 'left',
            marginTop: '4px',
            marginBottom: '0',
            marginLeft: '4px',
            color: '#FF3D57',
          }}
        >
          {helperText}
        </Typography>
      )}
    </>
  );
};
